import styled from 'styled-components/native';

import Touchable from '../../../../elements/Touchable';
import { LIST_GAP } from '../../styles';

const S = {
  TitleSection: styled.View<{ width: number }>`
    margin: 20px ${LIST_GAP}px 10px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: ${({ width }) => width - LIST_GAP * 2}px;
    flex: 1;
  `,
  TitleText: styled.Text`
    color: ${({ theme }) => theme.palette.warrior};
    font-size: 18px;
    line-height: 25px;
    font-weight: 700;
  `,
  MoreTopRatedText: styled.Text`
    color: ${({ theme }) => theme.palette.neutralDark};
  `,
  MoreTopRated: styled(Touchable)`
    flex-direction: row;
    align-items: center;
  `,
};

export default S;
